
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import QuillResizeImage from 'quill-resize-image';
import { useEffect, useRef, useState } from "react";
import { create_blog, get_types, upload_image, edit_type, edit_blog_post, get_create_blog } from "../../reduxData/user/userAction";
import { handleImageUpload } from "../Products/Latest/utils";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
const imageURL = process.env.REACT_APP_IMAGE_URL;
Quill.register("modules/resize", QuillResizeImage);
const modules = {
    toolbar: [
        [{ font: [] }, { size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
        [{ script: "sub" }, { script: "super" }],
        [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
        ],
        [{ direction: "rtl" }, { align: [] }],
        [{ color: [] }, { background: [] }],
        ["link", "image", "video"],
        ["clean"],
        [{ undo: "undo" }, { redo: "redo" }],
    ],
    resize: {},
    history: { delay: 1000, maxStack: 100, userOnly: true },
};

const Blogs = () => {
    const location = useLocation()
    const type = location?.state?.type
    const uplaoadRef = useRef(null);
    const uplaoadRef2 = useRef(null)
    const [option, setOptions] = useState([])
    const token = useSelector(State => State.auth.accessToken);
    const { state } = useLocation();
    const { id } = useParams()
    const lang = ["English", "Arabic"]
    const [language, setLang] = useState("English")
    const navigate = useNavigate();
    const blogIndexlength = state?.length;
    const filterBlog = async () => {
        if (state?.api === "edit") {
            const res = await get_create_blog();
            const data = res?.data?.find(
                item => String(item.blog_post_id) === String(id)
            );
            formik.setFieldValue("title", data?.title)
            formik.setFieldValue("title_ar", data?.title_ar)
            formik.setFieldValue("subtitle", data?.subtitle)
            formik.setFieldValue("subtitle_ar", data?.subtitle_ar)
            formik.setFieldValue("image", data?.image)
            formik.setFieldValue("author", data?.author)
            formik.setFieldValue("author_ar", data?.author_ar)
            formik.setFieldValue("author_des", data?.author_des)
            formik.setFieldValue("author_des_ar", data?.author_des_ar)
            formik.setFieldValue("author_image", data?.author_image)
            formik.setFieldValue("type_id", data?.type_id)
            formik.setFieldValue("textValue", data?.text_value)
            formik.setFieldValue("textValue_ar", data?.textvalue_ar)
            formik.setFieldValue("blog_post_id", id)
        }
    }

    useEffect(() => {
        const init = async () => {
            await data();
            await filterBlog();
        };
        init();
    }, []);


    const data = async () => {
        const apiRes = await get_types();
        const filteredTypes = apiRes?.data?.filter((i) => i?.is_deleted === false)
        setOptions(filteredTypes)
    }

    const edit_type_func = async () => {
        const res = await edit_type()
    }

    const formik = useFormik({
        initialValues: {
            type_id: null,
            title_ar: "",
            title: "",
            subtitle: "",
            subtitle_ar: "",
            image: null,
            author_des_ar: "",
            author_des: "",
            author_image: null,
            author_ar: "",
            author: "",
            textValue_ar: "",
            textValue: "",
            position_index: blogIndexlength + 1
        },
        validationSchema: Yup.object({
            type_id: Yup.number().required("Selcet the Category"),
            title: Yup.string().required(" Title is Required"),
            subtitle: Yup.string().required(" Subtitle is Required"),
            image: Yup.mixed().required(" Image is Required"),
            author_des: Yup.string().required("Description is Required"),
            author: Yup.string().required("Name is Required"),
            author_image: Yup.mixed().required("Image is Required"),
            textValue: Yup.string().required("TextValue is Required"),
        }),
        onSubmit: async (value, { resetForm }) => {
            if (state?.api === "edit") {
                await edit_blog_post(value);
                navigate("/blogdetail")
            } else {
                await create_blog(value);
                navigate("/blogdetail")
            }
            uplaoadRef.current.value = "";
            uplaoadRef2.current.value = "";
            resetForm();
        }
    })

    const formikData = formik?.values;
    const textHandleChange = (value) => {
        if (language === "English") {
            formik.setFieldValue("textValue", value)
        }
        if (language === "Arabic") {
            formik.setFieldValue("textValue_ar", value)
        }
    }
    const handleUploadImage = async (label, image) => {
        if (!image) return;
        const data = await upload_image(image, token);
        if (label === "image") {
            formik.setFieldValue("image", data?.data?.data)
        }
        if (label === "author_image") {
            formik.setFieldValue("author_image", data?.data?.data)
        }
    }
    console.log("labguagage", language)
    // console.log("formik is here", formik?.values)
    return (
        <>
            <div className="container-xxl ">
                <div className="d-flex gap-2">
                    {lang?.map((value, index) => (
                        <button
                            key={index}
                            onClick={() => setLang(value)}
                            className={`btn btn-sm rounded-pill d-flex align-items-center gap-2 px-3
                         ${language === value ? "btn-primary active-lang hindi-btn text-white" : "hindi-btn"}`}>
                            {value}
                        </button>
                    ))}
                </div>
                <form className="border border-1 rounded-3 p-2" onSubmit={formik.handleSubmit}>
                    <h3 className=" text-center w-fit px-3 py-2 mx-auto rounded-pill my-2 bg-primary text-white fw-semibold">Make Your Blog</h3>
                    <div className="form-switch">
                        <label htmlFor="id" className=" text-black fs-6 fw-medium py-2" >
                            {"Category"}
                        </label>
                        <select
                            name="type_id"
                            className="form-select text-capitalize"
                            value={formik.values.type_id || ""}
                            onChange={formik.handleChange}
                        >
                            <option value="" disabled>Select Category</option>

                            {option?.map((opt) => (
                                <option
                                    key={opt.id}
                                    value={opt.id}
                                    className="text-capitalize"
                                >
                                    {language === "English" ? opt.type_name : opt?.name_ar}
                                </option>
                            ))}
                        </select>
                        {formik.touched.type_id && formik.errors.type_id && (
                            <p className=" w-fit ms-0 text-danger  fw-semibold ">{formik.errors.type_id}</p>
                        )}
                    </div>
                    <div className="form-switch">
                        <label className="text-black fs-6 fw-medium py-2">
                            {"Blog title"}
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            name={language === "English" ? "title" : "title_ar"}
                            value={language === "English" ? formik?.values?.title : formik?.values?.title_ar}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />

                        {language === "English" &&
                            formik.touched.title &&
                            formik.errors.title && (
                                <p className="text-danger fw-semibold">{formik.errors.title}</p>
                            )}

                    </div>


                    <div className="form-switch">
                        <label className="text-black fs-6 fw-medium py-2">
                            Blog Subtitle
                        </label>
                        <input
                            name={language === "English" ? "subtitle" : "subtitle_ar"}
                            type="text" className=" form-control"
                            onChange={formik.handleChange}
                            value={language === "English" ? formik.values.subtitle : formik.values.subtitle_ar}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.subtitle && formik.errors.subtitle && (
                            <p className=" w-fit ms-0 text-danger  fw-semibold ">{
                                formik.errors.subtitle}</p>
                        )}
                    </div>


                    <div className=" form-switch">
                        <label className="text-black fs-6 fw-medium py-2">
                            {"Author Name"}
                        </label>
                        <input className=" form-control" type="text"
                            name={language === "English" ? "author" : "author_ar"}
                            onChange={formik.handleChange}
                            value={language === "English" ? formik.values.author : formik.values.author_ar}
                            onBlur={formik.handleBlur}
                        />

                        {formik.touched.author && formik.errors.author && (
                            <p className=" w-fit ms-0 text-danger  fw-semibold ">{
                                formik.errors.author}</p>
                        )}
                    </div>
                    <div className="form-switch">
                        <label className=" text-black fs-6 fw-medium py-2" htmlFor="author_des" >
                            {"Author Description"}

                        </label>
                        <input
                            onChange={formik.handleChange}
                            value={language === "English" ? formik.values.author_des : formik.values.author_des_ar}
                            onBlur={formik.handleBlur}
                            type="text" className="form-control" name={language === "English" ? "author_des" : "author_des_ar"} />
                        {formik.touched.author_des && formik.errors.author_des && (
                            <p className=" w-fit ms-0 text-danger fw-semibold ">{
                                formik.errors.author_des}</p>
                        )}
                    </div>

                    <div className=" form-switch">
                        <label className=" text-black fs-6 fw-medium py-2" htmlFor="author-image">
                            {"Author Image"}

                        </label>
                        <input
                            ref={uplaoadRef2}
                            className="form-control"
                            type="file"
                            name="author_image"
                            onChange={(e) => handleUploadImage("author_image", e.target.files[0])}
                            onBlur={formik.handleBlur}
                            id="author-image"
                        />

                        {formik.touched.author_image && formik.errors.author_image && (
                            <p className=" w-fit ms-0 text-danger fw-semibold ">{
                                formik.errors.author_image}</p>
                        )}
                        <div className={formikData?.author_image === null ? "d-none" : "image-upload"}>
                            <img src={`${imageURL}${formikData?.author_image}`} className="img-fluid" alt="auth-image" />
                            <i onClick={() => {
                                formik.setFieldValue("author_image", null)
                                uplaoadRef2.current.value = ""
                            }} className="bi bi-x-circle"></i>
                        </div>
                    </div>

                    <div className="form-switch">
                        <label htmlFor="image" className=" text-black fs-6 fw-medium py-2">
                            {"Blog image"}
                        </label>
                        <input
                            ref={uplaoadRef}
                            name="image"
                            type="file"
                            value={formik.values.files}
                            className="form-control"
                            onBlur={formik.handleBlur}
                            onChange={(e) => handleUploadImage("image", e.target.files[0])}
                        />
                        {formik.touched.image && formik.errors.image && (
                            <p className=" w-fit ms-0 text-danger fw-semibold ">{
                                formik.errors.image}</p>
                        )}
                        <div className={formikData?.image === null ? "d-none" : "image-upload"}>
                            <img src={`${imageURL}${formikData?.image}`} className="img-fluid" alt="auth-image" />
                            <i onClick={() => {
                                formik.setFieldValue("image", null)
                                uplaoadRef.current.value = ""
                            }} className="bi bi-x-circle"></i>
                        </div>
                    </div>
                    <div className={language === "English" ? "form-switch py-3 d-block" : "d-none"}>
                        <label className=" text-black fs-6 fw-medium py-2" >
                            {"Text Editor"}
                        </label>
                        <ReactQuill modules={modules} onChange={(value) => textHandleChange(value)}
                            value={formik.values.textValue} />
                        {formik.touched.textValue && formik.errors.textValue && (
                            <p className=" w-fit ms-0 text-danger fw-semibold ">{
                                formik.errors.textValue}</p>
                        )} </div>

                    <div className={language === "Arabic" ? "form-switch py-3 d-block" : "d-none"}>
                        <label className=" text-black fs-6 fw-medium py-2" >
                            {"Text Editor"}
                        </label>
                        <ReactQuill modules={modules} onChange={(value) => textHandleChange(value)}
                            value={formik.values.textValue_ar} />
                        {formik.touched.textValue && formik.errors.textValue && (
                            <p className=" w-fit ms-0 text-danger fw-semibold ">{
                                formik.errors.textValue}</p>
                        )} </div>
                    <div className=" form-switch">
                        <button type="submit" className=" btn btn-primary px-2 py-1 w-fit "> Submit</button>
                    </div>
                </form >
            </div >
        </>
    )
}
export default Blogs;